import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumCustomerHappinessRating implements BaseEnumType {
  private static allValues: EnumCustomerHappinessRating[] = []; // make sure this is top-most
  
  public static neutral = new EnumCustomerHappinessRating(0, "Neutral", "enum_customer_happiness_rating_neutral");
  public static positive = new EnumCustomerHappinessRating(1, "Positive", "enum_customer_happiness_rating_positive");
  public static negative = new EnumCustomerHappinessRating(2, "Negative", "enum_customer_happiness_rating_negative");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumCustomerHappinessRating.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNeutral() { return this === EnumCustomerHappinessRating.neutral; }
  public isPositive() { return this === EnumCustomerHappinessRating.positive; }
  public isNegative() { return this === EnumCustomerHappinessRating.negative; }

  public static getValues(): readonly EnumCustomerHappinessRating[] {
    return EnumCustomerHappinessRating.allValues;
  }

  public static getValuesExcept0(): readonly EnumCustomerHappinessRating[] {
    return EnumCustomerHappinessRating.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumCustomerHappinessRating {
    const found = EnumCustomerHappinessRating.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumCustomerHappinessRating - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumCustomerHappinessRating): EnumCustomerHappinessRating {
    const found = name ? EnumCustomerHappinessRating.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumCustomerHappinessRating - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumCustomerHappinessRating>): boolean {
    return this.key === other?.key;
  }
}